import CompaniesTable from './CompaniesTable'
import * as actions from './companies-table-actions'
import * as constants from './companies-table-constants'
import reducer from './companies-table-reducer'
import * as selectors from './companies-table-selectors'

export {CompaniesTable, actions, constants, reducer, selectors}
export default CompaniesTable
